import {Component, OnInit} from '@angular/core';
import {
    DASHBOARD_SETTINGS_COMPONENT, FORM_SETTINGS_COMPONENT,
    GENERAL_SETTINGS_COMPONENT,
    MAIN_SETTINGS_COMPONENT, VIEW_SETTINGS_COMPONENT
} from '../../SettingsUtility';

@Component({
    selector: 'smart-modal-view',
    templateUrl: './modal-view.component.html',
    styleUrls: ['./modal-view.component.css']
})
export class ModalViewComponent implements OnInit {
    componentStatus = new Map([
        [MAIN_SETTINGS_COMPONENT.name, MAIN_SETTINGS_COMPONENT.visible],
        [GENERAL_SETTINGS_COMPONENT.name, GENERAL_SETTINGS_COMPONENT.visible],
        [DASHBOARD_SETTINGS_COMPONENT.name, DASHBOARD_SETTINGS_COMPONENT.visible]
    ]);

    constructor() {
        this.componentStatus.set(MAIN_SETTINGS_COMPONENT.name, true);
    }

    ngOnInit(): void {
    }

    getGeneralStatus() {
        return this.componentStatus.get(GENERAL_SETTINGS_COMPONENT.name);
    }

    getDashboardStatus() {
        return this.componentStatus.get(DASHBOARD_SETTINGS_COMPONENT.name);
    }

    getMainStatus() {
        return this.componentStatus.get(MAIN_SETTINGS_COMPONENT.name);
    }

    hideMain(event: string) {
        this.componentStatus.set(MAIN_SETTINGS_COMPONENT.name, false);
        this.componentStatus.set(event, true);

    }

    handlEvent(activeComponentName: string) {
        this.componentStatus.set(activeComponentName, false);
        this.componentStatus.set(MAIN_SETTINGS_COMPONENT.name, true);

    }

    getViewStatus() {
        return this.componentStatus.get(VIEW_SETTINGS_COMPONENT.name);
    }

    getFormStatus() {
        return this.componentStatus.get(FORM_SETTINGS_COMPONENT.name);
    }
}
